


















  import { Component, mixins } from 'nuxt-property-decorator'
  import LazyHydrate from 'vue-lazy-hydration'
  import { namespace } from 'vuex-class'

  import { CMS } from '@one/types'
  import pages from '../breadcrumbs'
  import SeoMethodsMixin, { DIVIDER } from '~/mixins/SeoMethodsMixin'
  import { createStaticPageCmsComponents, CmsAsyncComponents } from '~/utils/cmsComponents'

  const cms = namespace('cms')
  const layout = namespace('layout')

  @Component({
    middleware: ['isAuthenticatedOrPlatformOpened'],
    meta: {
      breadcrumb: {
        name: pages.BLOG,
        link: '/blog',
      },
    },
    components: {
      OneCmsGridRender: () => import('~/components/molecules/renders/OneCmsGridRender.vue'),
      LazyHydrate,
    },
  })
  export default class Index extends mixins<SeoMethodsMixin>(SeoMethodsMixin) {
    @cms.Getter articleBySlug: any
    @cms.Getter logo: any
    @layout.State breadcrumbs: any
    @layout.Mutation('SET_BREADCRUMBS') setBreadcrumbs: any
    mainComponentClass = 'one-article-page'
    url = {} as Location

    availableComponents: CmsAsyncComponents = createStaticPageCmsComponents()

    mounted() {
      this.$plugins.onMounted(this.mainComponentClass, this)
      this.url = window.location
    }

    destroyed() {
      this.$plugins.onUnmounted(this.mainComponentClass)
    }

    head() {
      if (!this.$tenantConfig.tenantKey) {
        return {}
      }
      return {
        title: this.structuredSeoTitle(DIVIDER.DOT, [this.article.seo.title]),
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: this.structuredSeoTitle(DIVIDER.DASH, [this.article.seo.description]),
          },
          { property: 'og:image', content: this.article?.miniatureUrl ?? this.logo?.img ?? '', hid: 'og:image' },
          { property: 'og:title', content: this.structuredSeoTitle(DIVIDER.DOT, [this.article.seo.title]) },
          { property: 'og:description', content: this.structuredSeoTitle(DIVIDER.DASH, [this.article.seo.description]) },
          { property: 'og:url', content: this.url?.href ?? '' },
          { property: 'og:site_name', content: this.url?.origin ?? '' },
          { property: 'og:type', content: 'website' },
        ],
        script: [
          {
            type: 'application/ld+json',
            json: {
              '@context': 'https://schema.org',
              '@type': 'Article',
              about: {
                '@type': 'Event',
                name: 'Article',
              },
            },
          },
        ],
      }
    }

    created() {
      this.setBreadcrumbs([...this.breadcrumbs, { name: this.article.seo.title }].slice(0, 2))
    }

    get article(): CMS.Responses.ArticleBody {
      return this.articleBySlug(this.$route.params.article)
    }

    get bodyCss() {
      return this.article.bodyCss
    }

    get bannerUrl() {
      return this.article.bannerUrl
    }

    get bodyHtml() {
      return this.article.bodyHtml
    }

    get bodyJavascript() {
      return this.article.bodyJavascript
    }

    async fetch({ store, params, error }: any) {
      try {
        await store.dispatch('cms/fetchArticle', params.article)
        return Promise.resolve()
      } catch (err) {
        return error({
          statusCode: err.response && err.response.status,
          message: err.response && err.response.data,
          err: err,
        })
      }
    }
  }
